var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inner_item",attrs:{"type":"button","disabled":_vm.isEditMode},on:{"click":_vm.onSortItemClick}},[_c('span',{staticStyle:{"display":"inline-block"}},[_vm._t("default")],2),(_vm.isEditMode)?[(_vm.sortColumn === _vm.columnName)?_c('i',{staticClass:"sort_icon icon icon--sorting-white",class:{ asc: _vm.isSortAsc }}):_vm._e()]:_c('button',{staticClass:"sort",class:{
      asc: _vm.sortColumn === _vm.columnName && _vm.isSortAsc,
      desc: _vm.sortColumn === _vm.columnName && !_vm.isSortAsc,
      active: _vm.sortColumn === _vm.columnName
    }},[_c('i',{staticClass:"icon icon--sort-asc"}),_c('i',{staticClass:"icon icon--sort-desc"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }